import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import StaffDashboard from './pages/staff/Dashboard';
import TakeAttendance from './pages/staff/TakeAttendance';
import AttendanceHistory from './pages/staff/AttendanceHistory';
import AdminDashboard from './pages/admin/AdminDashboard';
import StaffManagement from './pages/admin/StaffManagement';
import AttendanceRecords from './pages/admin/AttendanceRecords';
import Settings from './pages/admin/Settings';

function PrivateRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}><span className="spinner spinner-dark" style={{ width: 36, height: 36 }} /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === 'admin' ? '/admin' : '/dashboard'} replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to={user.role === 'admin' ? '/admin' : '/dashboard'} replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />

      {/* Staff routes */}
      <Route path="/dashboard" element={<PrivateRoute role="staff"><StaffDashboard /></PrivateRoute>} />
      <Route path="/attendance" element={<PrivateRoute role="staff"><TakeAttendance /></PrivateRoute>} />
      <Route path="/history" element={<PrivateRoute role="staff"><AttendanceHistory /></PrivateRoute>} />

      {/* Admin routes */}
      <Route path="/admin" element={<PrivateRoute role="admin"><AdminDashboard /></PrivateRoute>} />
      <Route path="/admin/staff" element={<PrivateRoute role="admin"><StaffManagement /></PrivateRoute>} />
      <Route path="/admin/attendance" element={<PrivateRoute role="admin"><AttendanceRecords /></PrivateRoute>} />
      <Route path="/admin/settings" element={<PrivateRoute role="admin"><Settings /></PrivateRoute>} />

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: { borderRadius: 10, fontFamily: 'inherit', fontSize: '0.875rem' },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
